import React from 'react'
import './Footer.scss'

// eslint-disable-next-line
export default () => {
  return (
    <footer>
      Feito com React e Sass <br />
      Direitos de imagem para Netflix <br />
      Todas as informações foram retiradas do site themoviedb.org
    </footer>
  )
}